import { Button } from "..";
import { useModalContext } from "../../hooks/useModalContext";
import { ModalData } from "../../types/modal.type";

// https://www.figma.com/design/xnr558XUCXb4vkBy6eAif7/%5B%EB%9D%BC%EC%9D%B4%EB%B8%8C%EB%9F%AC%EB%A6%AC%5D-Potoo-Library?node-id=1624-3085&t=3lunUvpzgaQBTI5S-4
const Modal = () => {
  const { isOpen, modalData, closeModal } = useModalContext();

  if (!isOpen) {
    return <></>;
  }

  const {
    title,
    titleType = "heading3-700 gray-900",
    subTitle,
    subTitleBody,
    body,
    isCreditModal ,
    btn1type = "tertiary",
    btn1label = "",
    btn1icon,
    btn1disabled,
    btn1OnClick,
    btn1ClassName = "",
    btn2type = "secondary",
    btn2label = "",
    btn2icon,
    btn2disabled,
    btn2OnClick,
    btn2ClassName = "",
    bottomBody,
  }: ModalData = modalData;
  //console.log(isCreditModal);

  return (
    <div>
      <div className="modal-background" onClick={closeModal} />
      <div className={`modal ${isCreditModal ? 'credit-modal' : ''}`}>
        <div className="modal-box">
        <div className={`modal-container ${isCreditModal ? 'credit-modal-container' : ''}`}>
        {title || subTitle || subTitleBody ? (
              <div className="column center gap-8 text-align-center">
                {title && <span className={titleType}>{title}</span>}
                {subTitle && <p className="body1-500 gray-500 text-pre-line">{subTitle}</p>}
                {subTitleBody !== undefined && subTitleBody}
              </div>
            ) : null}
            {body !== undefined && body}
            {btn1label || btn2label ? (
              <div className="row space-between gap-16">
                {/* btn1 */}
                {btn1label && (
                  <Button
                    label={btn1label}
                    type={btn1type ?? "tertiary"}
                    icon={btn1icon ?? "none"}
                    size="large"
                    onClick={btn1OnClick}
                    otherClassName={`width-100p ${btn1ClassName}`}
                    disabled={!!btn1disabled}
                  />
                )}
                {/* btn2 */}
                {btn2label && (
                  <Button
                    label={btn2label}
                    type={btn2type ?? "secondary"}
                    icon={btn2icon ?? "none"}
                    size="large"
                    onClick={btn2OnClick}
                    otherClassName={`width-100p ${btn2ClassName}`}
                    disabled={!!btn2disabled}
                  />
                )}
              </div>
            ) : null}
          </div>
        </div>
        {bottomBody !== undefined && bottomBody}
      </div>
    </div>
  );
};

export { Modal };
